import HomeController from './home-controller'

export default HomeController
